module.exports = __webpack_public_path__ + "static_portal/media/crossfit_coach.6e79c259.mp4";